import { getAuthToken } from '@/lib/auth/auth-token';

/** Prefers the logged-in user's token; falls back to dev env override. */
export const getSocketAuthToken = (): string | undefined =>
  getAuthToken() ??
  (import.meta.env.VITE_SOCKET_AUTH_TOKEN as string | undefined);
